export default [
  {
    type: "bar",
    id: "greengas",
    unit: "",
    max: 20000,
    label: ["2021", "2022", "2023", "2024"],
    val1: [16186, 14989, 10768, 11433],
    val2: ["", "", "", 11155],
    y_split: 4,
  },
  {
    type: "line",
    id: "energykr",
    unit: "",
    max: 2,
    label: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
    val1: [1.064, 1.058, 1.059, 1.089, 1.271, 1.293, 1.359, 1.38, 1.339, 1.086, 1.062, 1.059],
    val2: [1.13, 1.113, 1.108, 1.119, 1.139, 1.184, 1.231, 1.239, 1.205, 1.137, 1.088, 1.083],
    y_split: 2,
    line: 1.14,
  },
  {
    type: "line",
    id: "energyen",
    unit: "",
    max: 2,
    label: ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
    val1: [1.064, 1.058, 1.059, 1.089, 1.271, 1.293, 1.359, 1.38, 1.339, 1.086, 1.062, 1.059],
    val2: [1.13, 1.113, 1.108, 1.119, 1.139, 1.184, 1.231, 1.239, 1.205, 1.137, 1.088, 1.083],
    y_split: 2,
    line: 1.14,
  },
  {
    type: "bar",
    id: "sun",
    unit: "",
    min: 200,
    max: 240,
    label: ["2021", "2022", "2023", "2024"],
    val1: [213, 207, 203, 200],
    val2: ["", "", "", 231],
    y_split: 3,
  },
  {
    type: "line",
    id: "earthkr",
    unit: "",
    max: 250,
    label: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
    val1: [232, 54, 62, 53, 82, 69, 171, 173, 143, 60, 68, 204],
    y_split: 5,
  },
  {
    type: "line",
    id: "earthen",
    unit: "",
    max: 250,
    label: ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
    val1: [232, 54, 62, 53, 82, 69, 171, 173, 143, 60, 68, 204],
    y_split: 5,
  },
];
